__turbopack_context__.v({
  "background__grey": "BulletBox-module___WaDjW__background__grey",
  "background__white": "BulletBox-module___WaDjW__background__white",
  "container": "BulletBox-module___WaDjW__container",
});
